import React, {createRef, useState} from 'react';
import __ from 'lodash';
import {
  Icon,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Slide,
  useTheme
} from '@material-ui/core';
import {Schedule} from "@material-ui/icons";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const IdleAlertDialog = (props) => {
  const formRef = createRef();
  const theme = useTheme();

  const [state, setState] = useState({open:false, error: false, errorMessage: null});

  if (state.open !== props.open) {
    setState({...state, open: props.open});
  }

  const defaultButtons = {
    cancel:{icon: "timer_off", label: "End Session", color: "secondary"},
    save:{icon: "timer", label: "Continue Session", color: "primary"},
  };

  const title = `Session Inactivity Timeout in ${props.countdown} seconds`;
  const message = `You will be logged out of your session due to inactivity. Would you like to continue the session?`;
  const buttons = {...defaultButtons, ...props.buttons};
  const onChange = props.onChange;


  const buttonHandler = (buttonPressed) => {
      onChange({buttonPressed, formRef});
  }

  return (
    <div>
      <Dialog id="form-dialog-slide"
        style={{zIndex: 2000}}
        open={props.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={(event, reason)=>{if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') buttonHandler(props.closeValue===undefined?false:props.closeValue)}}
        aria-labelledby="form-dialog-slide-title"
        aria-describedby="form-dialog-slide-description"
        // disableBackdropClick={true}
        {...props.dialogOptions}
      >
        <DialogTitle id="form-dialog-slide-title">
          <div style={{clear: "both", backgroundColor: theme.palette.primary.main, padding:"10px"}}>
            {title}
          </div>
        </DialogTitle>
        <DialogContent style={{display: "flex"}}>
          <IconButton color="primary" size="medium">
            <Schedule fontSize="large"/>
          </IconButton>
          <DialogContentText id="form-dialog-slide-description" style={{marginTop: 17}}>
            {message}
          </DialogContentText>
          <div ref={formRef}>
          </div>
          <div style={{height: 10, minHeight:10, maxHeight:10}}/>
        </DialogContent>
        <DialogActions>
          {
            Object.entries(buttons).map(([key, buttonProps]) => {
              const button = __.omit(buttonProps,['label', 'icon', 'iconOptions', 'onClick', 'disabled', 'hidden', 'startIcon']);
              const iconOptions = {color:"primary", ...props.iconOptions};
              button['onClick'] = ()=>buttonHandler(key);
              button['hidden'] = buttonProps.hidden;
              button['disabled'] = buttonProps.disabled;
              button['key'] = buttonProps.label;
              iconOptions['hidden'] = button.hidden;
              iconOptions['disabled'] = button.disabled;
              if (iconOptions.disabled) {
                iconOptions['color']=undefined;
              }

              if (buttonProps.icon) {
                button['startIcon'] = (<Icon {...iconOptions}>{buttonProps.icon}</Icon>);
              }

              return (
                <Button {...button}>
                  {buttonProps.label}
                </Button>
              )
            })
          }
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default IdleAlertDialog;
